<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :ColonneWidth="['2%', '15%', '18%', '15%']" :GetFunction="getDocuments">

        <template v-slot:Filter0>
            <ColumnFilter :title="$t('suppliers.documentsTab.headers.documentName')" :Filter="FieldName"
                :getList="getDocuments" @cancel="FieldName = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldName" id="FieldName" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter3>
            <ColumnFilter :title="$t('suppliers.creationDate')" :Filter="FieldCreatedDate" :getList="getDocuments"
                @cancel="FieldCreatedDate = null">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <dateField v-model="FieldCreatedDate" :minDate="new Date('2000-01-01')"
                            :max-date="new Date()" />
                    </span>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:item0="{ item }">
            <v-checkbox :disabled="(filterItemsFilter.includes(status))" style="color: #114ef7;" hide-details
                v-model="checkboxStates[item.name]" @change="valuesToCorrect(item.name, checkboxStates[item.name])">
            </v-checkbox>
        </template>
        <template v-slot:item1="{ item }">{{ item.name }}</template>
        <template v-slot:item2="{ item }">
            {{ item.created.split('T')[0] }} {{ item.created.split('T')[1].split('.')[0] }}
        </template>
        <template v-slot:edit="{ item }">
            <ClientDocumentsItemMenu :Id="index" :item="item" />
        </template>
    </gridComponent>
</template>
<script>
import gridComponent from "@/genericComponent/gridComponent.vue";
import ColumnFilter from "@/genericComponent/ColumnFilter.vue";
import dateField from "@/genericComponent/date-field.vue";
import { getClientsById } from "@/api";
import ClientDocumentsItemMenu from "./ClientDocumentsItemMenu.vue";
export default {
    components: {
        gridComponent,
        ColumnFilter,
        dateField,
        ClientDocumentsItemMenu
    },
    props: {
        idCompany: String,
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: [],
            item: null,
            idCustomer: "",
            itemsData: {},
            search: null,
            FieldName: null,
            FieldDeadline: null,
            FieldStatus: null,
            FieldCreatedDate: null,
            filterItemsFilter: [1, 3, 4],
            status: null,
            checkboxStates: {},
            dialogCompose: false,
            SortedBy: null,
            SortingType: null,
            dialogShowImage: false,
            dialogTitle: '',
            dialogImage: '',
        };
    },
    created() {
        this.idCustomer = this.$route.params.id;
        const storedArray = JSON.parse(localStorage.getItem(`toCorrect//${this.idCustomer}`)) || [];
        storedArray.forEach(name => {
            this.checkboxStates[name] = true;
        });
        this.getDocuments();
    },
    mounted() {
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
        })
    },
    unmounted() {
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
    },
    methods: {
        getDocuments: function () {
            getClientsById(this.idCustomer)
                .then(response => {
                    this.item = response.data;
                    this.status = this.item.accountStatus
                    this.items = [
                        { id: this.idCustomer, name: "license", created: this.item.created, url: this.item.patentFileUrl },
                        { id: this.idCustomer, name: "cin", created: this.item.created, url: this.item.cinFileUrl },]
                    this.itemsData.numberOfPage = 1;
                    this.itemsData.totalItemsCount = 3;
                    this.itemsData.pageNumber = 1;
                    this.itemsData.hasPreviousPage = false
                    this.itemsData.hasNextPage = false
                    this.loader = false;
                })
        },
        openDialog(item) {
            this.dialogTitle = this.$t("clients.generalInformation." + item.name);
            this.dialogImage = item.url;
            this.dialogShowImage = true;
        },
        valuesToCorrect(name, isSelected) {
            const storageKey = `toCorrect//${this.idCustomer}`;
            let array = JSON.parse(localStorage.getItem(storageKey)) || [];
            if (isSelected) {
                if (!array.includes(name)) {
                    array.push(name);
                }
            } else {
                array = array.filter(item => item !== name);

                if (array.length === 0) {
                    localStorage.removeItem(storageKey);
                    return;
                }
            }
            localStorage.setItem(storageKey, JSON.stringify(array));
        }
    },
    computed: {
        headers() {
            return [
                "Select",
                this.$t('suppliers.documentsTab.headers.documentName'),
                this.$t('suppliers.creationDate'),
            ]
        },
    }
};
</script>